export enum AccountMode {
    ATTENDANCE = 'ATTENDANCE',
    VEHICLE_MANAGEMENT = 'VEHICLE_MANAGEMENT',
}
  